import { createFileRoute } from "@tanstack/react-router";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { FaPlus } from "react-icons/fa6";
import ContentPage from "@/components/contentPage";
import useApiClient from "@/hooks/useApiClient";

import DataVolumeCard from "@/components/cards/dataVolumeCard";

const volumeListQueryOptions = (api: any) =>
  queryOptions({
    queryKey: ["listDataVolumes"],
    queryFn: () => api.dataTransfer.listDataVolumes({}),
  });

export const Route = createFileRoute("/data/volumes/")({
  component: DataVolumeList,
  loader: ({ context: { queryClient, api } }) =>
    queryClient.prefetchQuery(volumeListQueryOptions(api)),
});

function DataVolumeList() {
  const api = useApiClient();
  const [addingNewVolume, setAddingNewVolume] = useState(false);
  const [newDataVolumeName, setNewDataVolumeName] = useState("");

  const { isPending, data, refetch } = useQuery(volumeListQueryOptions(api));

  const handleNewDataVolume = async () => {
    await api.dataTransfer.registerDataVolume({
      requestBody: { name: newDataVolumeName },
    });
    setAddingNewVolume(false);
    setNewDataVolumeName("");
    await refetch();
  };

  if (isPending || !data) return "Loading...";

  return (
    <ContentPage title="Data Volumes">
      <div className="my-6 min-w-full divide-y divide-gray-200">
        <div className="space-y-4">
          {data.map((dataVolume: any) => (
            <DataVolumeCard key={dataVolume.name} dataVolume={dataVolume} />
          ))}
          {addingNewVolume && (
            <div className="mb-6 rounded-md bg-gray-100 p-4">
              <input
                onChange={(e) => setNewDataVolumeName(e.target.value)}
                onKeyDown={(e) => e.code === "Enter" && handleNewDataVolume()}
                value={newDataVolumeName}
                type={"text"}
                className="form-input mt-1 block w-full rounded text-blue-400"
                placeholder="Data Volume Name"
              />
              <button
                className="ox-button mt-4 w-full px-2 py-1"
                onClick={handleNewDataVolume}
              >
                Save
              </button>
            </div>
          )}
        </div>
        <div className="mb-4 flex">
          <div className={"grow"}></div>
          <button
            className="ox-button w-26 px-2 py-1"
            onClick={() => setAddingNewVolume(!addingNewVolume)}
          >
            <FaPlus />
            <span className={"pl-2"}>New Data Volume</span>
          </button>
        </div>
      </div>
    </ContentPage>
  );
}
